import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { AmorphicService } from '../../../services/amorphic/amorphic.service';
import { UnsupportedUseCasesService } from '../../../services/unsupportedUseCases/unsupportedUseCases.service';
import { AccountCenterService } from '../../../services/account-center/account-center.service';
import { GeoChangeService } from '../../../services/geoChange/geoChange.service';
import { FormGroup } from '@angular/forms';

@Component({
  moduleId: module.id,
  selector: 'correction-form',
  templateUrl: './correction-form.component.html',
})
export class CorrectionFormComponent implements OnInit {
  @Input() personType: string;
  @Output() toggle = new EventEmitter<string>();
  controller;
  personString: string;
  subjectString: string;
  correctionType: string;
  isSubmitting: boolean = false;
  showLegalInfoQuestions: boolean = false;

  constructor(
    private amorphicService: AmorphicService,
    private accountCenterService: AccountCenterService,
    private unsupportedUseCasesService: UnsupportedUseCasesService,
    private geoChangeSvc: GeoChangeService
  ) {
    this.controller = amorphicService.controller;
  }

  ngOnInit(): void {
    this.setSubjectString();

    this.accountCenterService.workflowStateSubject.subscribe((workflowState) => {
      this.setCorrectionType(workflowState);
    });
  }

  setSubjectString(): void {
    let subject;
    if (this.personType === 'owner') {
      this.personString = 'owner';
      subject = this.controller.customer.application.primaryPolicy.ownerType;
    } else {
      this.personString = 'insured.person';
      subject = this.controller.customer.application.primaryPolicy.insuredType;
    }
    switch (subject) {
      case 'you':
        this.subjectString = 'your';
        break;
      case 'spouse':
        this.subjectString = "your spouse's";
        break;
      case 'partnerfiance':
        this.subjectString = "your partner's";
        break;
      default:
        break;
    }
  }

  setCorrectionType(workflowStage: string): void {
    switch (workflowStage) {
      case 'TLIC Application:Correcting Insured SSN':
      case 'TLIC Application:Correcting Owner SSN':
      case 'TLIC Application:Correcting SSN':
        this.correctionType = 'ssn';
        break;
      case 'TLIC Application:Correcting License':
        this.correctionType = 'license';
        break;
      default:
        break;
    }
  }

  flipPage() {
    this.showLegalInfoQuestions = true;
    document.documentElement.scrollTop = 0;
  }

  toggleSpinner(status: boolean) {
    this.isSubmitting = status;
  }

  submitCorrection(): void {
    this.toggle.emit();
  }

  async setZip(fg: FormGroup): Promise<void> {
    try {
      const newZip = fg.get('zip').value;
      const oldZip = fg.get('oldZip').value;
      const oldState = fg.get('oldState').value;

      if (newZip === '') {
        return;
      }

      const zipLookup = await this.geoChangeSvc.zipCodeLookup(newZip);
      const newState = zipLookup['stateCode'];
      const addressProperty = this.getAddressProperty();
      const stateProperty = addressProperty + '.state';

      if (!(await this.unsupportedUseCasesService.isUnsupportedUseCase(stateProperty, newState))) {
        this.geoChangeSvc.handleApplicationZipCodeChangeNonpersistent(
          addressProperty,
          oldState,
          newZip,
          oldZip,
          'address-correction-partial',
          zipLookup
        );
      } else {
        //revert values to previously selected
        fg.get('zip').patchValue(oldZip);
      }
    } catch (e) {
      fg.get('zip').setErrors({ invalidZip: true });
    }
  }

  //exists solely to allow Zip Code geolocation check to run without erroring in this forms case
  private getAddressProperty(): string {
    return 'customer.application.primaryPolicy.' + this.personString + '.residentialAddress';
  }
}
